export const PARTNERS = [
  {img: "/static/images/souvenir/partners/fund.svg", text: "Проект реализован благодаря поддержке Фонда Президентских грантов", alt: "фонд президентских грантов"},
  {img: "/static/images/souvenir/partners/pochta-rossii.svg", text: "За помощь в организации доставки партнёрам из Почта России", alt: "почта россии"},
  {img: "/static/images/souvenir/partners/sensesay.svg", text: "За разработку дизайна значков", alt: "sensesay"},
  {img: "/static/images/souvenir/partners/target.svg", text: "Оперативно изготовили и надёжно упаковали значки", alt: "target"},
  {img: "/static/images/souvenir/partners/cdek.svg", text: "За помощь в организации доставки партнёрам из СДЭК", alt: "cdek"},
];

export const REVIEWS = [
  {
    id: 1,
    image: "/static/images/souvenir/reviews/review_1.png",
    title: "Антон, 47 донаций",
    text: <>
      Благодарен проекту DonorSearch за продвижение и популяризацию донорства. Это то место, где всегда помогут и ответят на все интересующие вас вопросы касаемо донорства и не только. Отзывчивые и веселые люди в чате,где всегда кипит общение)
      <br/><br/>
      От себя скажу: начал сдавать еще в университете и по сей день являюсь донором уже 7 год, при своей первой сдаче также решил вступить в РКДМ. Если решили начать сдавать кровь — не бойтесь, в этом нет ничего страшного, главное начать, ведь нет ничего лучше, чем осознание того, что ты помогаешь другим людям, для нас это всего лишь донация, а для репециента это шанс на успешное лечение и
      выздоровление. Если получили отвод, не отчаивайтесь и не теряйте запал, главное — не забрасывать всё и сразу, сам получал 2 раза отвод ,но все исправив, возвращался снова)
      <br/><br/>
      Проекту желаю развития и процветания. А донорам хороший гемоглобин и крепкого здоровья)
    </>,
  },
  {
    id: 2,
    image: "/static/images/souvenir/reviews/review_2.webp",
    title: "Ольга, 41 донация",
    text: "#DonorSearch - проект, который мотивирует. 20 донаций это только первый донорский экватор. Желаю всем здоровья, а проекту процветания.",
  },
  {
    id: 3,
    image: "/static/images/souvenir/reviews/review_3.jpg",
    title: "Алёна, 20 донаций",
    text: <>
      Лет пять назад мне сказали, что донором мне не быть — kell+ им не подошел, видите ли. Сначала обидно, а потом запал развернулся и ушел.
      <br/><br/>
      Потом нашелся человек, который был осведомлен больше некоторых врачей, и я неожиданно стала донором. Запал вернулся.
      <br/><br/>
      Три месяца назад свершилась моя 20-я донация. И последняя на неопределенный срок.
      <br/><br/>
      Точнее, на полгода, а дальше как пойдет. Опять обидно, но запал в этот раз ушел не сразу. Сначала хотелось всем доказать, что это ошибка.
      <br/><br/>
      Удостоверилась: ошибка. Запал отошел куда-то за угол. Думал.
      <br/><br/>
      Потом нашелся DonorSearch.<br/>
      Говорит, вот тебе бонусы всякие разные, вот тебе значок — повесь на грудь и гордись. Надела. Стою, горжусь.<br/>
      Недавно запал приходил, интересовался...
    </>,
  },
  {
    id: 4,
    image: "/static/images/souvenir/reviews/review_4.webp",
    title: "Артем, 125 донаций",
    text: "Добавляю на рюкзак такие загадочные значки. Есть прекрасный проект для развития донорства крови и костного мозга — DonorSearch. Ребята в федеральном масштабе от души топят за свое прекрасное дело. Развивая донорство и не давая ему сдавать позиции. Доноров не так много, и найти сотоварищей в жизни непросто. А в донорском чатике и соцсетях есть свой стендап на тему донорства, и люди меряются и количеством, и печеньками, и показателями крови, и веселятся, и находят поддержку, когда нахамили или когда вены тонкие. Это круто держит тусовку. Проект помогает находить доноров, когда острая ситуация и поддерживает учреждения крови. Чтобы доноры ставили себе цели и получали за это символические плюсики есть целая система интересных бонусов, теперь к ним добавились ещё и значки — 20 сдач это полпути к Почётному донору. 100 — красивая круглая цифра.",
  },
  {
    id: 5,
    image: "/static/images/souvenir/reviews/review_5.webp",
    title: "Виктория, 50 донаций",
    text: "20 донаций. Для кого-то это промежуточный финиш (ПД Москвы и Питера), для кого-то «экватор» в пути до ПДР....для меня это один взгляд назад....и дальше в путь к 100 донации с мотиваторами от DonorSearch",
  },
];

export const QUESTIONS = [
  {
    id: 0,
    question: 'Как мне загрузить донации на ваш сайт?',
    answer: <>
      Для подтверждения донаций мы принимаем справки из центра крови. Если они не сохранились, вы можете взять в центре крови справку 448-05у или 405-05у, в них указаны все ваши донации в конкретном учреждении, и загрузить справку в личном кабинете.
      <br/><br/>
      Еще можно на сайте Госуслуги увидеть все донации - <a href="https://www.gosuslugi.ru/donation">https://www.gosuslugi.ru/donation</a>. Принимаем скриншоты из сайта госуслуг, перейдите в КАЖДУЮ донацию (нажмите на "справка" в госуслугах) и сделайте скрин экрана, где указано ФИО ДОНОРА, место сдачи, дата и тип донации. Пример - <a href="https://disk.yandex.ru/i/OWD3NiRuRFf6tg">https://disk.yandex.ru/i/OWD3NiRuRFf6tg</a>
      <br/>
      Каждый скрин будет подтверждать соответствующую донацию.
      <br/><br/>
      Мы понимаем, что такое решение может показаться неудобным, но мы негосударственный некоммерческий проект и доступа к данным центров крови у нас нет. Единственный возможный для нас способ верифицировать донации — это справки.
    </>
  },
  {
    id: 1,
    question: 'Почему значки? Ведь можно было сделать медали!',
    answer: 'Мы делаем приятный и памятный сувенир, который можно было бы носить каждый день. При разработке дизайна мы сознательно решили уйти от образа серьёзной награды, медалей и так далее. Наши значки — это знак внимания и подарок от нашего проекта для тех, кто хочет его получить.',
  },
  {
    id: 2,
    question: 'Почему значки только 20, 30, 75, 100 и 150?',
    answer: <>
      В России за 40-60 донаций от государства выдается значок Почетный донор России (ПДР). Наши значки являются дополнительной мотивацией: значок "20 и 30" до ПДР и значки "75, 100 и 150" после ПДР.
      <br/><br/>
      Однако, вы <a href="https://market.yandex.ru/business--donorsearch-shop-magazin-soobshchestva-donorov/123729115" target="_blank" rel="noreferrer noopener">можете приобрести значок "50"</a>, если вам хочется в свою копилку дополнительный значок, а заодно поддержать развитие донорства вместе с крупнейшим сообществом доноров в России. <a href="https://market.yandex.ru/cc/MOmNKo8" target="_blank" rel="noreferrer noopener">Значок DonorSearch за 50 донаций</a> нас просили доноры сделать в дополнение к текущим значкам. Стоимость обусловлена ограниченным количеством и защитой от перекупов, для тех, кому действительно нужно.
      <br/>Этот значок представляет вашу приверженность миссии DonorSearch: сделать так, чтобы каждый центр крови ежедневно был обеспечен нужным количеством доноров с необходимыми параметрами крови.
      <br/><br/>
      DonorSearch — это не столько про кровь, сколько про людей. Мы мотивируем становиться донорами и поддерживаем на пути от первой сдачи крови к регулярным донациям.
    </>
  },
  {
    id: 3,
    question: 'Почему браслет без группы крови?',
    answer: <>
      Наши ресурсы ограничены, мы можем поддержать каждого донора только единожды. По запросам доноров и вместе с ювелирным брендом Amorem мы создали <a href="https://amorem.ru/catalog/kollektsii/kod_svyazi_/?utm_source=souvenir&utm_medium=donorsearch&utm_campaign=voprosi" target="_blank" rel="noreferrer noopener">коллекцию</a> серебряных браслетов с гравировкой группы крови. Каждый браслет — это не только стильный аксессуар для вас или ваших близких, но и поддержка развития донорства крови вместе DonorSearch.
    </>
    }
];

export const SOUVENIRS_LIST = [
  {
    id: 0,
    img: '/static/images/souvenir/souvenirs/znak-20.svg',
    name: 'Значок 20',
    codeName: 'pin_20',
  },
  {
    id: 1,
    img: '/static/images/souvenir/souvenirs/znak-30.svg',
    name: 'Значок 30',
    codeName: 'pin_30',
  },
  {
    id: 2,
    img: '/static/images/souvenir/souvenirs/znak-75.svg',
    name: 'Значок 75',
    codeName: 'pin_75',
  },
  {
    id: 3,
    img: '/static/images/souvenir/souvenirs/znak-100.svg',
    name: 'Значок 100',
    codeName: 'pin_100',
  },
  {
    id: 4,
    img: '/static/images/souvenir/souvenirs/znak-150.svg',
    name: 'Значок 150',
    codeName: 'pin_150',
  },
  {
    id: 5,
    img: '/static/images/souvenir/souvenirs/bracelet.svg',
    name: 'Браслет',
    codeName: 'bracelet',
  },
];

export const CREATED_STATUSES = ['created', 'in_progress', 'sent']